module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("New York")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("© 2019 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Haldipur, Jan, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: No place on the corner : the costs of aggressive policing / Jan Haldipur.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: New York : New York University Press, [2019] | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "tel:2018012213"
    }
  }, [_vm._v("2018012213")]), _vm._v(" | ISBN 9781479869084 (cl : alk. paper) | ISBN 9781479888009 (pb : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Police-community relations—New York (State)—New York. | Urban youth—New York (State)—New York—Social conditions. | Immigrants—New York (State)—New York—Social conditions. | Community development—New York (State)—New York. | Citizenship—New York (State)—New York. | Crime prevention—New York (State)—New York.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC HV8148.N5 H35 2018 | DDC 363.2/3097471—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2018012213",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018012213")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Also available as an ebook")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49538af4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/haldipur-0004.vue
// module id = 63
// module chunks = 0